import { render, staticRenderFns } from "./MenuTree.vue?vue&type=template&id=e9728910&scoped=true"
import script from "./MenuTree.vue?vue&type=script&lang=js"
export * from "./MenuTree.vue?vue&type=script&lang=js"
import style0 from "./MenuTree.vue?vue&type=style&index=0&id=e9728910&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9728910",
  null
  
)

export default component.exports